"use client";

import { useEffect, useState } from "react";
import { UserTrackingProvider } from "@/context/UserTrackingContext";
import { RouteChangeDetector } from "@/components/RouteChangeDetector";

export default function UserTrackingDeferred() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const enableTracking = () => setEnabled(true);

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const idleId = (window as Window & {
        requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
        cancelIdleCallback?: (id: number) => void;
      }).requestIdleCallback?.(enableTracking, { timeout: 5000 });

      return () => {
        if (typeof idleId === "number") {
          (window as Window & {
            cancelIdleCallback?: (id: number) => void;
          }).cancelIdleCallback?.(idleId);
        }
      };
    }

    const timer = globalThis.setTimeout(enableTracking, 2500);
    return () => globalThis.clearTimeout(timer);
  }, []);

  if (!enabled) {
    return null;
  }

  return (
    <UserTrackingProvider>
      <RouteChangeDetector />
    </UserTrackingProvider>
  );
}
